import React from 'react'
import {PaymentCheckoutPhoneTransaction} from '../containers'

export default function PaymentCheckoutPhoneScreen() {
  return <PaymentCheckoutPhoneTransaction />
}
